import Logger from 'Logger'
import { popShow } from '../../manager/mall.event'

export function validatePokerClass(attr) {
  Logger.info('[paymodel] validatePokerClass', 'model :', attr)

  if (!attr.isPolicyChecked) {
    popShow({
      title: '신청 동의 안내',
      message: '정기결제 동의 후에 <br /> 신청할 수 있습니다.',
      onClose: function () {
        this.hide()
      },
    })
    return 'NEED CHECK POLICY'
  }
}

// 모듬세트, 실속세트 등 구매전 동의 필요
export function validateBeforeBuyPackage(attr) {
  Logger.info('[paymodel] validateBeforeBuyPackage', 'model :', attr)

  if (!attr.isPolicyChecked) {
    popShow({
      title: '구매 동의 안내',
      message: '유의사항 동의 후<br /> 구매할 수 있습니다.',
      onClose: function () {
        this.hide()
      },
    })
    return 'NEED CHECK POLICY'
  }
}

export function validateGift(attr) {
  Logger.info('[paymodel] validateGift', 'model :', attr)

  var payModel = this

  if (!attr.isFriendSearched) {
    popShow({
      message: '선물하는 회원을 입력해 주세요.',
    })
    return 'NEED SELECT FRIEND'
  }

  if (attr.friendResultCode) {
    switch (attr.friendResultCode) {
      case 1:
        // 성공 리턴
        return
      case -1:
        popShow({
          message: '선택한 회원이 존재 하지 않습니다.',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'NOT_EXIST'
      case -2:
        popShow({
          title: '선물하기 불가',
          message:
            '선물하기를 할 수 없는 회원입니다.<br /> (선물받는 회원 구매한도 초과)',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'PURCHASE_LIMIT_OVER'
      case -3:
        popShow({
          title: '선물하기 불가',
          message: '선물을 할 수 없습니다. <br /> (이 번달 구매 한도 초과)',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'PURCHASE_LIMIT_OVER'
      case -4:
        popShow({
          title: '선물하기 불가',
          message: '선물하기를 할 수 없는 회원입니다.<br /> (클래스 보유 회원)',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'HAS_CLASSITEM'
      case -5:
        popShow({
          message: '상품정보가 없습니다. ',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'NO_ITEM_INFO'
      case -6:
        popShow({
          title: '선물하기 불가',
          message: '로그인한 계정에는 선물을 할 수 없습니다.',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'ACCOUNT_ERR'
      case -14:
        popShow({
          title: '선물하기 불가',
          message: '선물하기를 할 수 없는 회원입니다.<br /> (클래스 보유 회원)',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'HAS_CLASSITEM'
      case -21:
        popShow({
          title: '선물하기 불가',
          message:
            '친구가 게임 중 입니다. <br /> 게임 중에는 선물을 보낼 수 없습니다.',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'FRIEND_GAMEING'
      case 0:
      default:
        popShow({
          message: '선택한 회원에게 선물을 보낼수 없습니다.',
          onClose: function () {
            payModel.resetFriend()
            this.hide()
          },
        })
        return 'ERROR'
    }
  }
}
